/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Swift_Cod_AidInputs */

const en_mild_swift_cod_aid = /** @type {(inputs: Mild_Swift_Cod_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy from report`)
};

const de_mild_swift_cod_aid = /** @type {(inputs: Mild_Swift_Cod_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von Report kopieren`)
};

/**
* | output |
* | --- |
* | "Copy from report" |
*
* @param {Mild_Swift_Cod_AidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_swift_cod_aid = /** @type {((inputs?: Mild_Swift_Cod_AidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Swift_Cod_AidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_swift_cod_aid(inputs)
	return de_mild_swift_cod_aid(inputs)
});